import { cn } from "@/lib/utils";

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
	email: string;
	className?: string;
};
export const EmailLink: React.FC<Props> = ({
	email,
	className,
	...otherProps
}) => {
	return (
		<a
			href={`mailto:${email}`}
			className={cn("text-gold hover:underline", className)}
			{...otherProps}
		>
			{email}
		</a>
	);
};
